<template>
  <div
    :class="[
      'signatures',
    ]"
  >

    <div
      v-if="fetchState.status.value === 'success'"
      class="signatures__container animate__animated animate__fadeIn ease-in-out a3"
    >
      <div class="signatures__container__header">
        <div class="signatures__container__header__count">
          {{ toString_(total_signatures_disponibles_) }}
        </div>
        <div class="signatures__container__header__description">
          <div class="signatures__container__header__description__clickable-block" @click="() => historyVisible = !historyVisible">
            Signatures disponibles
            <ui-icon
              :name="historyVisible ?
                `arrow_drop_up`:
                `arrow_drop_down`
              "
              class="signatures__container__header__icon"
            />
          </div>
          <b-collapse v-model="historyVisible">
            <ui-wad class="signatures__divider my-1 mb-1" />
            <p class="mb-3 font-size-75 text-bold">Informations sur vos signatures</p>
            <ui-wad class="d-flex flex-direction-column gap-5">
              <div class="d-flex gap-3">
                <pack
                  :credit="solde.pack_en_cours.q_creditee"
                  :conso="solde.pack_en_cours.consommes"
                  :date="solde.pack_en_cours.date_achat"
                >
                  Pack en cours
                </pack>
                <pack
                  v-if="solde.pack_souscrit"
                  :credit="solde.pack_souscrit.q_creditee"
                  :date="solde.pack_souscrit.date_achat"
                >
                  Prochain pack
                </pack>
              </div>
              <div class="d-flex gap-3 flex-wrap">
                <pack
                  v-for="({ pack }, index) in solde.historique"
                  :key="index"
                  :credit="pack?.q_creditee"
                  :date="pack?.date_achat"
                >
                  Ancien pack
                </pack>
              </div>
            </ui-wad>
          </b-collapse>
        </div>
      </div>
      <div class="signatures__container__inner">
        <b-card class="signatures__container__inner__slider-block card--leveled">
          <p class="signatures__thin-text">Choisissez votre pack de signatures</p>
          <b-card class="signatures__container__inner__slider-block__slider">
            <hamac-signatures-slider
              :value="selectedPack"
              :data="articles"
              :min="minPack()"
              :max="maxPack()"
              :data-value="'nb_signatures'"
              :data-label="'nb_signatures'"
              @change="value => selectedPack = value"
            />
          </b-card>
          <ui-wad class="my-4">
            <p class="signatures__thin-text my-1">
              Informations du pack que vous avez choisi
            </p>
            <ui-wad class="d-flex flex-direction-row justify-content-space-between gap-2">
              <b-card class="d-flex w-1/4 pl-1">
                <div>
                  <p class="font-size-150 text-bold color-primary">
                    + {{ toString_(selectedPackData.nb_signatures) }}
                  </p>
                  <p>Signatures</p>
                </div>
              </b-card>
              <b-card class="d-flex w-1/4 pl-2">
                <div>
                  <p class="font-size-150">
                    {{ toString_(selectedPackData.prix_ht) }} €
                  </p>
                  <p>Prix HT</p>
                </div>
              </b-card>
              <b-card class="d-flex w-1/4 pl-2">
                <div>
                  <p class="font-size-150">
                    {{ toString_(selectedPackData.prix_ttc) }} €
                  </p>
                  <p>Prix TTC</p>
                </div>
              </b-card>
              <b-card class="d-flex w-1/4 pl-2">
                <div>
                  <p class="font-size-150">
                    {{ toString_(selectedPackData.prix_unite) }} €
                  </p>
                  <p>Prix unitaire</p>
                </div>
              </b-card>
            </ui-wad>
          </ui-wad>
        </b-card>
        <b-card class="signatures__container__inner__buying-block card--leveled">
          <p class="font-weight-bolder font-size-130 text-uppercase">Résumé de votre achat</p>
          <div class="signatures__container__inner__buying-block__resume-block">
            <div class="d-flex flex-direction-column mt-1">
            <div>
              <p class="float-left">Pack de {{ toString_(selectedPackData.nb_signatures) }} signatures</p>
              <p class="float-right signatures__text-monospace">{{ toString_(selectedPackData.prix_ht) }}€</p>
            </div>
            <ui-wad v-if="hasSmaDiscount" class="color-green">
                <p class="float-left">Remise SMA 10%</p>
                <p class="float-right signatures__text-monospace">-{{ toString_(smaDiscount) }}€</p>
              </ui-wad>
            </div>
            <ui-wad class="signatures__divider my-1" />
            <div class="d-flex flex-direction-column">
              <div>
                <p class="float-left">TVA</p>
                <p class="float-right signatures__text-monospace">{{ toString_(taxesAmount) }}€</p>
              </div>
            </div>
            <ui-wad class="signatures__divider my-1" />
            <div v-if="hasSmaDiscount" class="d-flex flex-direction-column text-bold mb-1">
              <div>
                <p class="float-left">Total après remise</p>
                <p class="float-right signatures__text-monospace">{{ toString_(totalAfterDiscount) }}€</p>
              </div>
            </div>
            <div v-else class="d-flex flex-direction-column text-bold mb-1">
              <div>
                <p class="float-left">Total</p>
                <p class="float-right signatures__text-monospace">{{ toString_(totalWithoutSma) }}€</p>
              </div>
            </div>
          </div>
          <div v-if="canBuy">
            <p class="mt-3 mb-2 font-weight-bolder font-size-110 text-uppercase">Choisir le mode de paiement</p>
            <div class="d-flex justify-content-space-between">
              <div
                :class="['signatures__pay-button', {
                  'signatures__pay-button--active': paymentMethod === PAIEMENT_METHOD.CARTE,
                }]"
                @click="() => paymentMethod = PAIEMENT_METHOD.CARTE"
              >
                <p class="text-align-center">Carte bancaire</p>
                <img class="h-4" :src="'/images/payment/logo-cb.svg'" alt="Carte bancaire logo">
              </div>
              <div
                :class="['signatures__pay-button', {
                  'signatures__pay-button--active': paymentMethod === PAIEMENT_METHOD.SEPA,
                }]"
                @click="() => paymentMethod = PAIEMENT_METHOD.SEPA"
              >
                <p class="text-align-center">Prélèvement</p>
                <img class="h-3" :src="'/images/payment/logo-sepa.png'" alt="Sepa logo">
              </div>
            </div>
            <ui-form-checkbox
              v-if="hasSmaDiscount"
              v-model="remise_sma"
              class="mt-5 mb-1"
            >
              Je suis toujours adhèrent à la SMA
            </ui-form-checkbox>
          </div>
          <div v-else>
            <ui-caveat
              :aside-variant="UI.VARIANT.PRIMARY"
              class="my-2"
            >
              <template #aside>
                <ui-icon name="warning" class="color-white" />
              </template>
              <template #default>
                <ui-wad>
                  <p>Vous disposez déja d'un pack souscrit, veuillez finir un de vos packs avant de procéder à un nouvel achat</p>
                </ui-wad>
              </template>
            </ui-caveat>
          </div>
          <ui-tooltip-wrapper
            v-bind="{
              title: 'Vous devez choisir un mode de paiement pour continuer',
              variant: UI.VARIANT.PRIMARY,
            }"
            :status="tooltipStatus"
          >
            <layout-cta-super
              component="ui-button"
              class="w-1 mt-1"
              :status="payButtonStatus"
              :variant="UI.VARIANT.PRIMARY"
              @click="checkout"
            >
              Continuer
            </layout-cta-super>
          </ui-tooltip-wrapper>
        </b-card>
      </div>
    </div>

    <div v-else class="signatures__placeholder">
      <ui-spinner
        :variant="UI.VARIANT.LIGHT"
        :type="UI.SPINNER_TYPE.GROW"
        class="signatures__placeholder__spinner"
      />
    </div>

    <!-- CONFIRMATION MODAL -->
     <ui-modal
      :id="CONFIRMATION_MODAL_NAME"
      :size="UI.SIZE.MEDIUM"
      no-header
      no-footer
      no-outside-close
    >
      <confirmation-modal
        :payment-info="paymentConfirmationInfo"
        @close="hideModal(CONFIRMATION_MODAL_NAME)"
      />
    </ui-modal>
    <!-- CONFIRMATION MODAL -->

    <!-- CIC FORM HTML -->
    <div ref="cicFormHtmlRef" v-html="cicFormHtml" />
    <!-- CIC FORM HTML -->
  </div>
</template>

<style lang="sass" scoped>
@import ~/assets/sass/modules/layout/members
@import ~/assets/sass/modules/client/members

$header-height: 84px
$padding-value: 24px
$footer-height: 25px
$unusable-vertical-space: $header-height + ($padding-value * 5) + $footer-height

.signatures

  &__placeholder
    height: 80vh
    display: flex
    align-items: center
    justify-content: center

    &__spinner
      width: 48px
      height: 48px

  &__form-input.ui-form-input
    font-family: $font-family-monospace

  &__thin-text
    font-family: $font-family-base-condensed
    margin-bottom: space-x(1)
    font-size: 120%

  &__text-monospace
    font-family: $font-family-monospace

  &__divider
    width: 100%
    height: 1px
    background-color: $border-color

  &__pay-button
    padding: space-x(2)
    width: 40%
    cursor: pointer
    display: flex
    align-items: center
    flex-direction: column
    justify-content: center
    border: 1px solid
    border-color: $card-border-color
    border-radius: 8px
    background-color: $background-primary

    &--active
      border-color: $primary
      color: $primary

  &__container
    padding: 24px 24px

    &__header
      display: flex
      gap: space-x(2)
      margin-bottom: space-x(1.5)

      &__count
        font-size: 130%
        font-weight: $font-weight-bolder
        font-family: $font-family-monospace
        border-radius: $border-radius-lg
        padding: space-x(2)
        background-color: $gray-dark
        color: $background-primary
        text-align: center
        flex-basis: 150px

        @include media('<desktop')
          flex-basis: 100px

      &__description
        font-size: 150%
        background: linear-gradient(to bottom right, mix($background-secondary, $background-tertiary, 50%), mix($gray-bright, $background-primary, 30%))
        padding: space-x(1.5) space-x(2)
        flex-grow: 1
        border-radius: $border-radius-lg
        overflow: hidden
        position: relative
        font-family: $font-family-base-condensed

        &__clickable-block
          @include clickable

      &__icon
        color: $primary
        font-size: 28px
        margin-left: 3px
        padding-bottom: 3px

    &__inner
      width: 100%
      min-height: calc(100vh - $unusable-vertical-space)
      display: flex
      flex-direction: row
      gap: space-x(2)
      min-width: map-get($breakpoints, 'tablet')
      @include media('<1400px')
        flex-direction: column

      &__slider-block
        width: 70%
        background: linear-gradient(to top, mix($background-secondary, $background-tertiary, 50%), $background-primary)
        @include media('<1400px')
          width: 100%
        &__slider
          padding: space-x(2)
          padding-bottom: space-x(4)

      &__buying-block
        width: 30%
        background: linear-gradient(to top, $background-secondary, $background-tertiary)
        @include media('<1400px')
          width: 100%

        &__resume-block
          margin-top: space-x(2)
          border: 1px $border-color solid

          > *:not(.signatures__divider)
            padding-left: space-x(2)
            padding-right: space-x(2)
</style>

<script lang="ts">
import { add, subtract, multiply, divide, round } from 'mathjs'
import { propEq, toString, isEmpty, findOr, equals, sort, split, pipe, nth, always, tap, when, pluck, pathOr, Maybe, pipe_, head_, last_ } from '~/utils/lib/core/prelude'
import { STATUS } from '~/utils/lib/layout/ui'
import ConfirmationModal from '~/components/hamac/signatures/ConfirmationModal.vue'
import Pack from '~/components/hamac/signatures/Pack.vue'
import { PAIEMENT_METHOD, useStore_hamac_signatures_infos, type Article, type PaymentInfo, type Solde } from '~/stores/hamac/signatures/infos'
import { isDatetimeGreaterThan } from '~/utils/lib/core/datetime'
import Console from '~/utils/lib/core/console'
import * as Float from '~/utils/lib/core/float'
import { useLegacyPageFetch } from '~/composables/core/hook'
import { useToastBuilder } from '~/composables/layout/toast'
import { useLegacyModalController } from '~/composables/layout/modal'
import { animate } from 'motion-v'
import { useDataOnlyNavigationContext } from '~/composables/layout/navigation'
import { querySelector2 } from '~/utils/lib/core/dom'
import { useStore_hamac_signatures_paiements_cic } from '~/stores/hamac/signatures/paiements/cic'
import { useStore_hamac_ficheClient_infos } from '~/stores/hamac/fiche-client/infos'
import { useStore_account_details } from '~/stores/account/details'
import { useStore_hamac_signatures_paiements_sepa } from '~/stores/hamac/signatures/paiements/sepa'
import { getSignaturesRoute, getSignaturesSepaFormRoute } from '~/stores/parametres'
import { MENU_ITEM, NAVIGATION_SCOPE } from '~/utils/lib/layout/types'

const console = new Console('component:page-parametres-signatures')
const CONFIRMATION_MODAL_NAME = 'CONFIRMATION_MODAL'

export default defineComponent({
  components: {
    ConfirmationModal,
    Pack,
  },
  setup() {
    definePageMeta({
      menuItem: MENU_ITEM.PARAMETERS_SIGNATURES,
      navigationScope: NAVIGATION_SCOPE.DATA_ONLY,
      middleware: [
        'session-control-gate',
      ]
    })

    const navigationContext = useDataOnlyNavigationContext()

    useHead({
      title: `Signatures — ${navigationContext.fromStructureLevel().structure.raison}`,
    })

    const {
      fetchState,
      fetchWrapper,
    } = useLegacyPageFetch()

    const {
      hideModal,
      showModal,
    } = useLegacyModalController()

    const ToastBuilder = useToastBuilder()

    const ref_cicFormHtmlRef
      = useTemplateRef<HTMLDivElement>('cicFormHtmlRef')

    const store_signatures_paiements_cic = useStore_hamac_signatures_paiements_cic()
    const store_signatures_paiements_sepa = useStore_hamac_signatures_paiements_sepa()
    const store_signature_infos = useStore_hamac_signatures_infos()
    const store_ficheClient_infos = useStore_hamac_ficheClient_infos()
    const store_account_details = useStore_account_details()

    return {
      ...navigationContext,
      fetchState,
      fetchWrapper,
      hideModal,
      showModal,
      ToastBuilder,
      ref_cicFormHtmlRef,
      store_signatures_paiements_cic,
      store_ficheClient_infos,
      store_account_details,
      store_signatures_paiements_sepa,
      store_signature_infos,
    }
  },
  data() {
    return {
      hasSmaDiscount: false,
      /* CONSTS */
      isEmpty,
      PAIEMENT_METHOD,
      CONFIRMATION_MODAL_NAME,
      /* CONSTS */

      /* SIGNATURES API INFO */
      historyVisible: false,
      /* SIGNATURES API INFO */

      /* SIGNATURES API INFO */
      espaceClientInfos: null, // lazy
      solde: null as unknown as Solde, // lazy
      articles: [] as Array<Article>,
      total_signatures_disponibles_: 0,
      paymentConfirmationInfo: null as unknown as PaymentInfo, // lazy
      /* SIGNATURES API INFO */

      /* FORM INFO */
      selectedPack: 0,
      paymentMethod: '',
      iban: '',
      remise_sma: false,
      /* FORM INFO */

      /* PAYMENT */
      loadingPayment: false,
      cicFormHtml: '', // HTML src for CIC form
      /* PAYMENT */
    }
  },
  computed: {
    selectedPackData() {
      return findOr(
        head_(this.articles),
        propEq('nb_signatures', this.selectedPack),
        this.articles
      )
    },
    taxesAmount() {
      const fullTva = subtract(this.selectedPackData.prix_ttc, this.selectedPackData.prix_ht)
      if (!this.hasSmaDiscount) {
        return Float.cast('round', 2, fullTva)
      }
      return Float.cast(
        'round',
        2,
        divide(
          multiply(fullTva, subtract(this.selectedPackData.prix_ht, this.smaDiscount)),
          this.selectedPackData.prix_ht
        )
      )
    },
    smaDiscount() {
      return Float.cast(
        'round',
        2,
        multiply(
          this.selectedPackData.prix_ht,
          0.1
        )
      )
    },
    totalAfterDiscount() {
      return Float.cast(
        'round',
        2,
        add(
          subtract(this.selectedPackData.prix_ht, this.smaDiscount),
          this.taxesAmount
        )
      )
    },
    totalWithoutSma() {
      return Float.cast(
        'round',
        2,
        this.selectedPackData.prix_ttc
      )
    },
    canBuy() {
      return isEmpty(this.solde.pack_souscrit)
    },
    payButtonStatus() {
      if (this.loadingPayment) return STATUS.DEFFERED
      if (isEmpty(this.paymentMethod)) return STATUS.DISABLED
      if (!this.canBuy) return STATUS.DISABLED
      return STATUS.ENABLED
    },
    tooltipStatus() {
      if (this.loadingPayment) return STATUS.DISABLED
      if (isEmpty(this.paymentMethod)) return STATUS.ENABLED
      if (!this.canBuy) return STATUS.DISABLED
      return STATUS.DISABLED
    }
  },
  watch: {
    solde: {
      handler() {
        if (isEmpty(this.solde)) return

        animate(0, this.solde.total_signatures_disponibles, {
          duration: 1,
          ease: 'easeOut',
          onUpdate: (value) => {
            this.total_signatures_disponibles_ = round(value)
          }
        })
      },
      immediate: true
    },
  },
  created() {
    this.fetchWrapper(
      () => this.fetch()
    )
  },
  methods: {
    toString_: Float.toString,
    minPack() {
      return head_(this.articles).nb_signatures
    },
    maxPack() {
      return last_(this.articles).nb_signatures
    },
    getBuyerName(details) {
      if (details.prenom ) {
        return { firstName: details.prenom, lastName: details.nom }
      }
      const firstName = pipe_(
        details.nom,
        split(' '),
        nth(0),
        when(
          isEmpty,
          pipe(
            tap(() => {
              console.log('first name not found for account ', details)
            }),
            always('Prénom vide')
          )
        ),
      )

      const lastName = pipe_(
        details.nom,
        split(' '),
        nth(1),
        when(
          isEmpty,
          pipe(
            tap(() => {
              console.log('last name not found for account ', details)
            }),
            always('Prénom vide')
          )
        ),
      )

      return { firstName, lastName }
    },
    getReference(selectedPack) {
      const signatureCount = pipe_(
        selectedPack.id,
        split('Sig'),
        nth(1),
        when(
          isEmpty,
          always('')
        ),
      )

      if (isEmpty(signatureCount)) {
        console.log('unknown pack reference ', selectedPack)
        return 'Pack inconnu'
      } else {
        return `Pack de ${signatureCount} signatures`
      }
    },
    async checkout() {
      try {
        const {
          structure: { id, code_client },
        } = this.fromStructureLevel()

        switch (true) {
          case equals(this.paymentMethod, PAIEMENT_METHOD.CARTE): {
            this.loadingPayment = true

            const returnUrl = getSignaturesRoute(id)

            this.cicFormHtml = await this.store_signatures_paiements_cic.create(
              {
                code: code_client,
                article: this.selectedPackData.id,
                remise_sma: this.remise_sma,
                url_retour: returnUrl,
              }
            )

            // @XXX Monetico / CIC payment
            // the monetico micro-service sends back a hidden <form> element that
            // needs to be inserted in the page, it is inserted via the cicFormHtml
            // state the form needs to be submitted to continue the payment process
            await this.$nextTick()

            Maybe.toMaybe(this.ref_cicFormHtmlRef)
              .chain(element => querySelector2<HTMLFormElement>('form', element))
              .map(element => {
                // @XXX some users hit back on the payment page, and end up seeing the spinner again
                // KISS workaround
                this.loadingPayment = false
                element.submit()
              })

            break
          }
          case equals(this.paymentMethod, PAIEMENT_METHOD.SEPA): {
            this.loadingPayment = true

            const infos = await this.store_ficheClient_infos.read(
              {
                code: code_client,
              }
            )

            const userDetails = this.store_account_details.$state
            const { firstName, lastName } = this.getBuyerName(userDetails)

            const price = this.remise_sma ?
              this.totalAfterDiscount :
              this.totalWithoutSma

            this.store_signatures_paiements_sepa.$patch(
              {
                pack: this.selectedPackData,
                titulaire_compte: infos.raison_sociale,
                price,
                reference: this.getReference(this.selectedPackData),
                remise_sma: this.remise_sma,
                email: userDetails.mail,
                nom: lastName,
                prenom: firstName,
              }
            )

            this.$router.push(getSignaturesSepaFormRoute(id))
          }
        }
      } catch (err) {
        this.loadingPayment = false
        console.warn(err, 'signature checkout')
        return this.ToastBuilder
          .error('Erreur lors du paiement: ' + toString(err))
          .title('Signatures')
          .show()
      }
    },
    displayConfirmationModal() {
      this.$nextTick(() => {
        const paymentId = this.$route.query.payment_id as string

        if (isEmpty(paymentId))
          return

        const cic = !isEmpty(this.$route.query.cic)
        const sepa = !isEmpty(this.$route.query.sepa)

        const options = {
          code: this.fromStructureLevel().structure.code_client,
          payment_id: paymentId,
        }

        switch (true) {
          case cic: {
            return this.store_signatures_paiements_cic.checkPayment(options)
              .then((paymentConfirmationInfo) => {
                this.paymentConfirmationInfo = {
                  ...paymentConfirmationInfo,
                  solde: this.solde,
                  mode: PAIEMENT_METHOD.CARTE
                }
                this.showModal(CONFIRMATION_MODAL_NAME)
              })
              .catch((err) => {
                this.ToastBuilder
                  .error('Erreur lors de la vérification du paiement: ' + toString(err))
                  .title('Signatures')
                  .show()
              })
          }
          case sepa: {
            this.store_signatures_paiements_sepa.$reset()

            return this.store_signatures_paiements_sepa.checkPayment(options)
              .then((paymentConfirmationInfo) => {
                this.paymentConfirmationInfo = {
                  ...paymentConfirmationInfo,
                  solde: this.solde,
                  mode: PAIEMENT_METHOD.SEPA
                }
                this.showModal(CONFIRMATION_MODAL_NAME)
              })
              .catch((err) => {
                this.ToastBuilder
                  .error('Erreur lors de la vérification du paiement: ' + toString(err))
                  .title('Signatures')
                  .show()
              })
          }
        }
      })
    },
    async fetch() {
      this.store_signatures_paiements_sepa.$reset()

      try {
        const options = {
          code: this.fromStructureLevel().structure.code_client,
        }

        const articles = await this.store_signature_infos.articles(options)
        const solde = await this.store_signature_infos.solde(options)

        const historique = sort(({ pack }, { pack: otherPack }) => {
          const options = { inputFormat: undefined }

          return isDatetimeGreaterThan(
            options,
            otherPack.date_achat,
            options,
            pack.date_achat
          ) ?
          1 :
          -1
        })(solde.historique)

        solde.historique = historique

        this.solde = solde
        this.articles = articles
        this.remise_sma = solde.remise_sma
        this.hasSmaDiscount = solde.remise_sma

        const latestBoughtPack = pathOr(
          solde.pack_en_cours.q_creditee,
          ['pack_souscrit', 'q_creditee'],
          solde
        )

        const signatures = pluck('nb_signatures')(articles)

        // Choose the closest pack in value to the one the user has bought lastly
        // ex: last pack = 50, choose option 100
        const closestPack = signatures.reduce(( previousNbSignatures, currentNbSignatures) => {
          return Math.abs(currentNbSignatures - latestBoughtPack) < Math.abs(previousNbSignatures - latestBoughtPack) ? currentNbSignatures : previousNbSignatures
        })

        await this.$nextTick()

        this.selectedPack = closestPack
        this.displayConfirmationModal()

      } catch (err) {
        console.warn('fetch', err)
        this.ToastBuilder
          .error('Erreur lors de la récupération des infos: ' + toString(err))
          .title('Signatures')
          .show()
      }
    }
  },
})
</script>
